export const MODERATOR = 'moderator';
export const BILLER = 'biller';
export const SUPERVISOR = 'supervisor';
export const EDITOR = 'editor';
export const CORRECTOR = 'corrector';
export const JORNALIST = 'journalist';

export const ROLES = [{
  value: MODERATOR,
  label: 'Модератор',
}, {
  value: JORNALIST,
  label: 'Журналист',
}, {
  value: BILLER,
  label: 'Биллер',
}, {
  value: EDITOR,
  label: 'Редактор',
}, {
  value: CORRECTOR,
  label: 'Корректор',
}, {
  value: SUPERVISOR,
  label: 'Суперюзер',
}];

export const ROLES_OBJECT = ROLES.reduce((acc, role) => ({ ...acc, [role.value]: role.label }), {});

export const PUBLICATION_STATE_PERMISSIONS = {
  lock: {
    draft: [JORNALIST, EDITOR, SUPERVISOR],
    processing: [JORNALIST, CORRECTOR, EDITOR, SUPERVISOR],
    published: [JORNALIST, CORRECTOR, EDITOR, SUPERVISOR],
    hidden: [JORNALIST, CORRECTOR, EDITOR, SUPERVISOR],
  },
  publish: {
    draft: [EDITOR, SUPERVISOR],
    processing: [EDITOR, SUPERVISOR],
    published: [],
    hidden: [EDITOR, SUPERVISOR],
  },
  sendToApprove: {
    draft: [JORNALIST, EDITOR, SUPERVISOR],
    processing: [],
    published: [],
    hidden: [JORNALIST, EDITOR, SUPERVISOR],
  },
  editorApprove: {
    draft: [],
    processing: [EDITOR, SUPERVISOR],
    published: [EDITOR, SUPERVISOR],
    hidden: [],
  },
  correctorApprove: {
    draft: [],
    processing: [CORRECTOR, SUPERVISOR],
    published: [CORRECTOR, SUPERVISOR],
    hidden: [],
  },
  hide: {
    draft: [],
    processing: [],
    published: [EDITOR, SUPERVISOR],
    hidden: [],
  },
  delete: {
    draft: [JORNALIST, EDITOR, SUPERVISOR],
    processing: [EDITOR, SUPERVISOR],
    published: [],
    hidden: [EDITOR, SUPERVISOR],
  },
  save: {
    draft: [JORNALIST, EDITOR, SUPERVISOR],
    processing: [JORNALIST, EDITOR, CORRECTOR, SUPERVISOR],
    published: [JORNALIST, EDITOR, CORRECTOR, SUPERVISOR],
    hidden: [JORNALIST, EDITOR, SUPERVISOR],
  },
  filterStateChange: {
    all: [JORNALIST, EDITOR, CORRECTOR, SUPERVISOR],
    draft: [JORNALIST, EDITOR, SUPERVISOR],
    processing: [JORNALIST, EDITOR, CORRECTOR, SUPERVISOR],
    published: [JORNALIST, EDITOR, CORRECTOR, SUPERVISOR],
    hidden: [JORNALIST, EDITOR, SUPERVISOR],
  },
};

const checkState = ({ permission, roles, state }) => (
  PUBLICATION_STATE_PERMISSIONS[permission][state].some(role => roles.indexOf(role) !== -1)
);

export const PERMISSIONS = {
  pages: {
    materials: { roles: [MODERATOR] },
    biller: { roles: [BILLER] },
    users: { roles: [MODERATOR] },
    employees: { roles: [] },
    galleries: { roles: [JORNALIST, EDITOR] },
    snoozes: { roles: [EDITOR] },
    publications: { roles: [JORNALIST, EDITOR, CORRECTOR] },
    publicationNew: { roles: [JORNALIST, EDITOR] },
    audit: { roles: [] },
    ar: { roles: [] },
    avatar: { roles: [EDITOR] },
  },
  publications: {
    create: { roles: [JORNALIST, EDITOR] },
    filterStateChange: { roles: [JORNALIST, EDITOR, CORRECTOR], when: checkState },
  },
  publication: {
    lock: { roles: [JORNALIST, EDITOR, CORRECTOR], when: checkState },
    unlock: { roles: [] },
    changeCover: { roles: [JORNALIST, EDITOR] },
    changeType: { roles: [JORNALIST, EDITOR] },
    changeAuthor: { roles: [JORNALIST, EDITOR] },
    changeSource: { roles: [JORNALIST, EDITOR] },
    selectSnoozes: { roles: [JORNALIST, EDITOR] },
    changePositiveReaction: { roles: [JORNALIST, EDITOR] },
    changeNegativeReaction: { roles: [JORNALIST, EDITOR] },
    changeMascot: { roles: [JORNALIST, EDITOR] },
    changeEmotion: { roles: [JORNALIST, EDITOR] },
    changePublishedAt: { roles: [JORNALIST, EDITOR] },
    changeDestination: { roles: [JORNALIST, EDITOR] },
    changeCheckbox: { roles: [JORNALIST, EDITOR] },
    publish: { roles: [EDITOR], when: checkState },
    sendToApprove: { roles: [JORNALIST, EDITOR], when: checkState },
    editorApprove: { roles: [EDITOR], when: checkState },
    correctorApprove: { roles: [CORRECTOR], when: checkState },
    hide: { roles: [EDITOR], when: checkState },
    delete: { roles: [JORNALIST, EDITOR], when: checkState },
    save: { roles: [JORNALIST, EDITOR, CORRECTOR], when: checkState },
  },
  users: {
    remuneration: { roles: [MODERATOR, BILLER] },
  },
};

export function can({ permission, resource, ...rest }) {
  const { roles } = this.state.profile;

  if (PERMISSIONS[resource][permission].when &&
    !PERMISSIONS[resource][permission].when({ permission, roles, ...rest })) return false;

  if (roles.indexOf(SUPERVISOR) !== -1) return true;

  return PERMISSIONS[resource][permission].roles.some(currentValue => roles.indexOf(currentValue) !== -1);
}

export default ROLES;
